import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../../StateProvider';
import { fetchAllFamilyMember, fetchAllUsers } from '../../../Utilities/api';
import { BackButton } from '../../../Utilities/components/Buttons';
import './Pets.css';

/* Small helpers (ES6-safe) */
function pcVal(v, fallback) {
  if (v === null || v === undefined || v === '') return (typeof fallback !== 'undefined' ? fallback : 'N/A');
  return v;
}
function pcCap(s) {
  return (s && typeof s === 'string') ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

const Pets = () => {
  const navigate = useNavigate();
  const { user } = useContext(StateContext) || {};

  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({ dog: false, cat: false, owner: false });
  const [usersAndPets, setUsersAndPets] = useState([]);
  const [allUsersAndPets, setAllUsersAndPets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);

  useEffect(function onMount() {
    async function getUsersAndPets() {
      try {
        const familyMembers = await fetchAllFamilyMember();
        const users = await fetchAllUsers();

        const userMap = new Map(users.map(function(u){ return [u.uid, u]; }));

        const combined = [];

        // Owner rows
        users.forEach(function(u){
          const userPets = familyMembers
            .filter(function(m){ return m.userid === u.uid && m.type !== 'Human'; })
            .map(function(pet){
              return { name: pet.name, type: pet.type, breed: pet.breed, image: pet.image };
            });

          combined.push({
            name: u.username,
            type: 'Human',
            breed: '',
            ownerName: u.username,
            ownerImage: u.image,
            isPet: false,
            pets: userPets,
            uid: u.uid,
            image: u.image
          });
        });

        // Pet rows
        familyMembers
          .filter(function(m){ return m.type !== 'Human'; })
          .forEach(function(p){
            const own = userMap.get(p.userid);
            if (own) {
              combined.push({
                id: p.id,
                uid: p.id,
                userId: own.uid,
                name: p.name,
                type: p.type,
                breed: p.breed,
                age: p.age,
                image: p.image,
                ownerName: own.username,
                ownerImage: own.image,
                isPet: true,
              });
            }
          });

        setAllUsersAndPets(combined);
        setUsersAndPets(combined);
      } catch (err) {
        console.error('Error fetching users or family members:', err);
      }
    }

    getUsersAndPets();
  }, [user]);

  useEffect(function filterList(){
    const next = allUsersAndPets.filter(function(row){
      var s = (searchTerm || '').toLowerCase();

      // --- text match ---
      var nameMatch = false;
      if (row.isPet) {
        var nm = (row.name || '').toLowerCase();
        var br = (row.breed || '').toLowerCase();
        var tp = (row.type  || '').trim().toLowerCase(); // FIX
        nameMatch = (
          (nm.indexOf(s) > -1) ||
          (br.indexOf(s) > -1) ||
          (tp.indexOf(s) > -1)
        );
      } else {
        var ownerHas = ((row.name || '').toLowerCase().indexOf(s) > -1);
        var anyPetHas = false;
        var petsA = row.pets || [];
        for (var i = 0; i < petsA.length; i++) {
          var p = petsA[i];
          var pnm = (p.name  || '').toLowerCase();
          var pbr = (p.breed || '').toLowerCase();
          var ptp = (p.type  || '').trim().toLowerCase(); // FIX
          if (pnm.indexOf(s) > -1 || pbr.indexOf(s) > -1 || ptp.indexOf(s) > -1) {
            anyPetHas = true;
            break;
          }
        }
        nameMatch = ownerHas || anyPetHas;
      }

      // --- type match (dog/cat) ---
      var wantDog = !!filters.dog;
      var wantCat = !!filters.cat;
      var typeMatch = true;

      if (wantDog || wantCat) {
        if (row.isPet) {
          var t = (row.type || '').trim().toLowerCase(); // FIX
          var isDog = t.indexOf('dog') > -1;             // FIX
          var isCat = t.indexOf('cat') > -1;             // FIX
          typeMatch = (wantDog && isDog) || (wantCat && isCat);
        } else {
          var hasDog = false;
          var hasCat = false;
          var petsB = row.pets || [];
          for (var j = 0; j < petsB.length; j++) {
            var pt = (petsB[j].type || '').trim().toLowerCase(); // FIX
            if (pt.indexOf('dog') > -1) hasDog = true;
            if (pt.indexOf('cat') > -1) hasCat = true;
          }
          var matchDog = wantDog ? hasDog : false;
          var matchCat = wantCat ? hasCat : false;
          typeMatch = matchDog || matchCat;
        }
      }

      // --- category match (Owners checkbox) ---
      var categoryMatch = !filters.owner || !row.isPet;

      return nameMatch && typeMatch && categoryMatch;
    });

    setUsersAndPets(next);
    setCurrentPage(1);
  }, [searchTerm, filters, allUsersAndPets]);

  function handleCheckboxChange(type) {
    setFilters(function(prev){ 
      var copy = Object.assign({}, prev);
      copy[type] = !prev[type];
      return copy;
    });
  }

  function handleCardClick(data) {
    if (data.isPet) {
      navigate('/console/petInfo/' + data.uid);
    } else {
      navigate('/console/userInfo/' + data.uid);
    }
    try { window.scrollTo(0, 0); } catch (e) {}
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = usersAndPets.slice(indexOfFirstItem, indexOfLastItem);

  function paginate(pageNumber) { setCurrentPage(pageNumber); }
  function prevPage() { if (currentPage > 1) setCurrentPage(currentPage - 1); }
  function nextPage() {
    const max = Math.ceil(usersAndPets.length / itemsPerPage);
    if (currentPage < max) setCurrentPage(currentPage + 1);
  }

  var pageNumbers = [];
  var totalPages = Math.ceil(usersAndPets.length / itemsPerPage);
  for (var i = 1; i <= totalPages; i++) pageNumbers.push(i);

  return (
    <div className="pc-page">
      <div className="pc-topbar">
        <BackButton />
        <div className="pc-topbar-right">
          <div className="pc-search">
            <input
              type="text"
              placeholder="Search pets or owners"
              value={searchTerm}
              onChange={function(e){ setSearchTerm(e.target.value); }}
              className="pc-input"
            />
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="pc-card pc-filters">
        <div className="pc-filter-row">
          <label className="pc-check">
            <input
              type="checkbox"
              checked={filters.dog}
              onChange={function(){ handleCheckboxChange('dog'); }}
            />
            <span>Dogs</span>
          </label>
          <label className="pc-check">
            <input
              type="checkbox"
              checked={filters.cat}
              onChange={function(){ handleCheckboxChange('cat'); }}
            />
            <span>Cats</span>
          </label>
          <label className="pc-check">
            <input
              type="checkbox"
              checked={filters.owner}
              onChange={function(){ handleCheckboxChange('owner'); }}
            />
            <span>Owners</span>
          </label>
        </div>
      </div>

      {/* List */}
      <div className="pc-grid">
        {currentItems.map(function(data, idx){
          const isPet = !!data.isPet;
          const title = pcVal(data.name, isPet ? 'Pet' : 'Owner');
          const sub = isPet ? ('Breed: ' + pcVal(data.breed, 'N/A')) : 'Owner';
          const kind = pcCap(pcVal(data.type, isPet ? 'Pet' : 'Human'));
          const imgSrc = data.image;

          return (
            <div
              key={idx}
              className="pc-card pc-card-item"
              onClick={function(){ handleCardClick(data); }}
              role="button"
              tabIndex={0}
              onKeyDown={function(e){ if (e.key === 'Enter') handleCardClick(data); }}
            >
              {/* Avatar */}
              <div className="pc-avatar">
                {imgSrc ? (
                  <img src={imgSrc} alt={title} />
                ) : (
                  <div className="pc-avatar-fallback">{title.charAt(0)}</div>
                )}
                <span className={'pc-badge ' + (isPet ? 'pc-badge-blue' : 'pc-badge-slate')}>
                  {kind}
                </span>
              </div>

              {/* Info */}
              <div className="pc-info">
                <div className="pc-title-row">
                  <h4 className="pc-title">{title}</h4>
                </div>
                <p className="pc-sub">{sub}</p>

                {isPet ? (
                  <div className="pc-meta-row">
                    <span className="pc-meta">
                      <span className="pc-meta-label">Owner</span>
                      <span className="pc-meta-value">{pcVal(data.ownerName)}</span>
                    </span>
                  </div>
                ) : (
                  (data.pets && data.pets.length > 0) ? (
                    <div className="pc-pet-chips">
                      {data.pets.map(function(p, jdx){
                        var label = p.name + ' (' + pcVal(p.type) + (p.breed ? ', ' + p.breed : '') + ')';
                        return (
                          <span key={jdx} className="pc-chip">{label}</span>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="pc-empty-inline">No pets yet</div>
                  )
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pc-pagination">
          <button className="pc-page-btn" onClick={prevPage} disabled={currentPage === 1}>
            Prev
          </button>
          <div className="pc-page-list">
            {pageNumbers.map(function(n){
              return (
                <button
                  key={n}
                  onClick={function(){ paginate(n); }}
                  className={'pc-page-index' + (currentPage === n ? ' pc-page-index--active' : '')}
                >
                  {n}
                </button>
              );
            })}
          </div>
          <button
            className="pc-page-btn"
            onClick={nextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default Pets;
